
// Local-only mode: Firebase imports removed to prevent any connection attempts
// import { initializeApp } from "firebase/app";
// import { getFirestore, collection, getDocs, setDoc, doc, deleteDoc, query, orderBy } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "LOCAL_ONLY",
  authDomain: "local",
  projectId: "local",
  storageBucket: "local",
  messagingSenderId: "000000000000",
  appId: "local",
  measurementId: "local"
};

let db: any = null;
let useCloud = false;

// Force local mode
console.log("MDS System: Running in LOCAL-ONLY mode (Cloud permanently disabled).");

/**
 * DEEP SANITIZE: Menghapus nilai 'undefined' secara rekursif.
 */
const sanitizeData = (data: any): any => {
  if (data === undefined) return null;
  if (data === null) return null;
  if (Array.isArray(data)) {
    return data.map(v => sanitizeData(v));
  }
  if (typeof data === 'object') {
    const clean: any = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const value = sanitizeData(data[key]);
        if (value !== undefined) {
          clean[key] = value;
        }
      }
    }
    return clean;
  }
  return data;
};

const local_save = (key: string, id: string, data: any) => {
  try {
    const current = JSON.parse(localStorage.getItem(key) || "{}");
    current[id] = data;
    localStorage.setItem(key, JSON.stringify(current));
  } catch (e) { console.error(e); }
};

const local_get = (key: string) => {
  try {
    const data = JSON.parse(localStorage.getItem(key) || "{}");
    return Object.values(data).sort((a: any, b: any) => 
      new Date(b.uploadedAt || 0).getTime() - new Date(a.uploadedAt || 0).getTime()
    );
  } catch (e) { return []; }
};

const local_delete = (key: string, id: string): boolean => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) {
        console.warn(`Local delete failed: Key ${key} is empty.`);
        return false;
    }
    
    const data = JSON.parse(raw);
    const initialCount = Object.keys(data).length;
    
    const newStorage: any = {};
    let found = false;
    
    // Normalize ID for comparison
    const targetId = String(id).trim();

    Object.keys(data).forEach(k => {
        const item = data[k];
        
        // Robust matching
        // Check key match
        const keyMatch = k === targetId || k.trim() === targetId;
        
        // Check content match (dwg_number or id)
        const dwgMatch = item?.dwg?.dwg_number && String(item.dwg.dwg_number).trim() === targetId;
        const stdMatch = item?.id && String(item.id).trim() === targetId;
        
        if (keyMatch || dwgMatch || stdMatch) {
            found = true;
            console.log(`Match found for deletion: ${targetId} (Key: ${k})`);
        } else {
            newStorage[k] = item;
        }
    });
    
    if (found) {
        localStorage.setItem(key, JSON.stringify(newStorage));
        console.log(`Deleted ${id} from ${key}. Count: ${initialCount} -> ${Object.keys(newStorage).length}`);
        return true;
    }
    
    console.warn(`Local delete failed: Item ${id} not found in ${key} (${initialCount} items).`);
    // Debug: print keys to see why it failed
    console.log("Available keys:", Object.keys(data));
    return false;
  } catch (e) { 
      console.error("Local delete error:", e); 
      return false;
  }
};

export const getSyncStatus = (): "LOCAL" | "CLOUD" => "LOCAL";
export const isConfigured = () => true;

export const firebase_getFiles = async () => {
  const files = local_get("mds_files_v2");
  return files;
};

export const firebase_saveFile = async (data: any) => {
  if (!data?.dwg?.dwg_number) throw new Error("Invalid Drawing Number");
  const dwgId = data.dwg.dwg_number;
  const cleanData = sanitizeData(data);
  local_save("mds_files_v2", dwgId, cleanData);
  return true;
};

export const firebase_deleteFile = async (dwgNumber: string) => {
  const result = local_delete("mds_files_v2", dwgNumber);
  return result;
};

export const firebase_deleteAllFiles = async () => {
  localStorage.removeItem("mds_files_v2");
  return true;
};

export const firebase_getStandards = async () => {
  const stds = local_get("mds_standards_v2");
  return stds;
};

export const firebase_saveStandard = async (standard: any) => {
  const cleanStandard = sanitizeData(standard);
  local_save("mds_standards_v2", cleanStandard.id, cleanStandard);
};

export const firebase_deleteStandard = async (id: string) => {
  const result = local_delete("mds_standards_v2", id);
  return result;
};
